import {
  HabitSchedule,
  ScheduleEntryState,
  Timestamp,
  WeekDays,
} from '@griply/types';

import { isBetween } from './lib/date-fns';
import { getScheduleTimeframeByDate } from './schedules/get-schedule-timeframe-by-date';

export type Options = {
  referenceDate: Timestamp;
  weekStartsOn: WeekDays;
  countFailAsComplete?: boolean;
  countSkipAsComplete?: boolean;
};

export const getFrequencyTimeframeCompletions = (
  schedule: HabitSchedule,
  {
    referenceDate,
    weekStartsOn,
    countFailAsComplete,
    countSkipAsComplete,
  }: Options,
) => {
  const { startDate, endDate } = getScheduleTimeframeByDate(
    schedule,
    referenceDate,
    weekStartsOn,
  );

  const completions = schedule.entries.filter(
    ({ date, state }) =>
      (state === ScheduleEntryState.Complete ||
        (countFailAsComplete && state === ScheduleEntryState.Failure) ||
        (countSkipAsComplete && state === ScheduleEntryState.Skip)) &&
      isBetween(date, startDate, endDate),
  );

  return {
    completionsCount: completions.reduce(
      (acc, { value, state }) =>
        acc +
        (value ??
          ([ScheduleEntryState.Failure, ScheduleEntryState.Skip].includes(state)
            ? 1
            : 0)),
      0,
    ),
    target: schedule.frequency?.count ?? 1,
  };
};
